import type { ReactElement } from 'react';
import { PIECHART_COMPACT_CENTER, PIECHART_COMPACT_INNER_CIRCLE_RADIUS, } from './piechart-constants';
import type { PieChartCompactSector } from './piechart-types';
interface PieChartCompactPreviewProps {
    sectors: ReadonlyArray<PieChartCompactSector>;
}
export function PieChartCompactPreview({ sectors, }: PieChartCompactPreviewProps): ReactElement {
    return (
      <svg viewBox="0 0 100 100" width="100%" height="100%" style={{ position: 'absolute', inset: 0, display: 'block' }}>
        <circle cx={PIECHART_COMPACT_CENTER} cy={PIECHART_COMPACT_CENTER} r={PIECHART_COMPACT_INNER_CIRCLE_RADIUS} fill="rgba(5,17,11,0.9)"/>
        {sectors.map((sector) => (<path key={sector.debugIdentity} d={sector.pathData} fill={sector.color} opacity={0.85}/>))}
      </svg>
    );
}
